import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_get_accessorial_charges_templates_full_dataService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { template_ids: number[] }): 
  Promise<{ result: { Id?: number, Enabled?: boolean, LookupCode?: string, BillingAccessorialChargeTemplateLines?: { Id?: number, BillingAccessorialChargeTemplateId?: number, OperationCodeId?: number, BillingRates?: { Id?: number, BillingAccessorialChargeTemplateLineId?: number, BillingCodeId?: number, BillingContractLineId?: number, LookupCode?: string, MinimumCharge?: number, PerAmount?: number, RangeEnd?: number, RangeStart?: number, Rate?: number, TypeId?: number }[], OperationCode?: { Id?: number, Name?: string } }[] }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.template_ids)) {
      $missingRequiredInParams.push('\'template_ids\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { template_ids: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Enabled?: boolean, LookupCode?: string, BillingAccessorialChargeTemplateLines?: { Id?: number, BillingAccessorialChargeTemplateId?: number, OperationCodeId?: number, BillingRates?: { Id?: number, BillingAccessorialChargeTemplateLineId?: number, BillingCodeId?: number, BillingContractLineId?: number, LookupCode?: string, MinimumCharge?: number, PerAmount?: number, RangeEnd?: number, RangeStart?: number, Rate?: number, TypeId?: number }[], OperationCode?: { Id?: number, Name?: string } }[] }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.template_ids)) {
      $missingRequiredInParams.push('\'template_ids\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { template_ids: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, Enabled?: boolean, LookupCode?: string, BillingAccessorialChargeTemplateLines?: { Id?: number, BillingAccessorialChargeTemplateId?: number, OperationCodeId?: number, BillingRates?: { Id?: number, BillingAccessorialChargeTemplateLineId?: number, BillingCodeId?: number, BillingContractLineId?: number, LookupCode?: string, MinimumCharge?: number, PerAmount?: number, RangeEnd?: number, RangeStart?: number, Rate?: number, TypeId?: number }[], OperationCode?: { Id?: number, Name?: string } }[] }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.template_ids)) {
      $missingRequiredInParams.push('\'template_ids\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      template_ids: number[]    }) {
        if(isNil($inParams.template_ids)) {
          return true; 
        }
      return false;
    }
}
